const cookie = {
    hasCookie: (key) => {
        return document.cookie.split(';').some(function(item) {
            return item.indexOf(`${key}=`) >= 0
        });
    },

    // クッキーのkeyで値を取得
    getCookie: (key) => {
        const cookies = document.cookie;

        const cookiesArray = cookies.split('; ');

        const cookie = cookiesArray.filter(function(item) {
            return item.includes(`${key}=`)
        });

        return cookie[0].split('=')[1];
    },

    // クッキーをセット
    setCookie: (key, val, expire) => {
        document.cookie = `${key}=${val}; max-age=${expire}; path=/; samesite=Lax;`;
    },

    // クッキーの削除
    deleteCookie: (key) => {
        document.cookie = `${key}=; max-age=0`;
    }
}

export default cookie;